import { render, staticRenderFns } from "./AnimatedShape.vue?vue&type=template&id=39173503&scoped=true"
import script from "./AnimatedShape.vue?vue&type=script&lang=js"
export * from "./AnimatedShape.vue?vue&type=script&lang=js"
import style0 from "./AnimatedShape.vue?vue&type=style&index=0&id=39173503&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39173503",
  null
  
)

export default component.exports